// M145 — EmbedContext: laat AppLayout weten of ze in een wrapper zit.
// Wrapper-pagina's (Content, Kanalen, Resultaten, Markt, Instellingen) zetten
// deze provider op `{ embedded: true }`. AppLayout leest de context en
// skipt sidebar+header (rendert alleen `{children}`) zodat de bestaande
// pagina-componenten netjes ingebed kunnen worden zonder dubbele shell.
import { createContext, useContext } from "react";
export const EmbedContext = createContext({ embedded: false, hideInnerHeader: false });
export const useEmbed = () => useContext(EmbedContext);
